import React from 'react';
import cs from 'classnames';
import DocumentTitle from 'react-document-title';
import {Helmet} from 'react-helmet';
import {connect} from 'react-redux';

import states from '~/misc/states';
import * as searchHelper from '~/misc/search';
import loadsURL from '~/modules/loadsSearch/url';
import {loadsSearch} from '~/modules/loadsSearch/actions';
import mapDispatch from '~/misc/mapDispatch';

import sharedCSS from '../shared.css';
import css from './index.css';

const topStates = ['TX', 'CA', 'FL', 'GA', 'PA', 'IL', 'OH', 'NC'];
const createQuery = (fromState, toState) => ({
  ...(fromState
    ? {
      from_state: fromState,
      from_name: states[fromState],
      from_st: true,
    } : {}
  ),
  ...(toState
    ? {
      to_state: toState,
      to_name: states[toState],
      to_st: true,
    }
    : {}),
});

const Direction = connect((state, {fromState, toState}) => ({
  query: createQuery(fromState, toState),
}), mapDispatch({
  view: ({fromState, toState}, e) => {
    e.preventDefault();
    return loadsSearch(createQuery(fromState, toState));
  },
}))(({fromState, toState, query, view}) => {
  const url = loadsURL(searchHelper.coerceQueryTypes(query));

  return (
    <div key={fromState} className={css.direction}>
      <span className={css.codeName}>{fromState && `${fromState}`}</span>{' '}
      <a className={css.link} href={url} onClick={view}>

        <span>{states[fromState] || 'Anywhere'}</span>
        {toState && <span> → {states[toState]}</span>}
      </a>
    </div>
  );
});

const Directions = () => (<div className={cs(sharedCSS.wideStretchable, sharedCSS.box, css.directions)}>
  <DocumentTitle title={'Find truck loads to haul to diffent directon - Truckloads'}/>
  <Helmet>
    <meta
      name='description'
      content={`Find truck loads to haul from ${topStates.map(state => states[state]).join(', ')}`}
    />
  </Helmet>
  <h1 className={css.header}>Find truck loads to haul from</h1>
  <div className={css.list}>
    <Direction/>
    {
      topStates.map(state => <Direction key={state} fromState={state}/>)
    }
  </div>

</div>);

export default Directions;



// WEBPACK FOOTER //
// ./src/components/Directions/index.js